import { render, staticRenderFns } from "./editPrivacyPolicy.vue?vue&type=template&id=370f5d89&scoped=true&"
import script from "./editPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./editPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f5d89",
  null
  
)

export default component.exports